import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page/Page";
import UserRouteMiddleware from "./middleware/auth/userValidRoute";
import RoleMngtRouteMiddleware from "./middleware/auth/roleMngtValidRoute";

// ✅ Lazy load pages
const ChangePassword = lazy(() => import("app/pages/ChangePassword"));
const ConfigureRole = lazy(() => import("app/pages/RoleManagement/ConfigureRole"));
const ListRole = lazy(() => import("app/pages/RoleManagement/ListRole"));
const RoleLogTable = lazy(() => import("app/pages/RoleManagement/RolesLog"));
const AddUser = lazy(() => import("app/pages/UserManagement/AddUser"));
const ListUser = lazy(() => import("app/pages/UserManagement/ListUser"));
const UserLogTable = lazy(() => import("app/pages/UserManagement/UserLog"));

const userManagementRoutes = [
  {
    middleware: [
      {
        element: UserRouteMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/user",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListUser} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/adduser",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddUser} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/edituser",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddUser} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/user/log",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={UserLogTable} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/changepassword",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ChangePassword} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: RoleMngtRouteMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/roles",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListRole} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/roles/log",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={RoleLogTable} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/addrole",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ConfigureRole} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/editrole",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ConfigureRole} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
];

export default userManagementRoutes;
